import { Auth } from 'aws-amplify';
import { TAmplifySignInUserData } from 'data/types/Amplify.types';

export const currentAmplifyAuthUser =
  async (): Promise<TAmplifySignInUserData> => {
    return Auth.currentAuthenticatedUser();
  };
